// extracted by mini-css-extract-plugin
export default {"iframe":"FramePreview_iframe__W6jz+"};